import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { ActivitySection } from '../components/ActivitySection';
import { SocialImpactSection } from '../components/SocialImpactSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function BeachClubPage() {
  // Set RTL direction for the entire page
  useEffect(() => {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'he';
    // Set meta tags for social sharing
    document.title = "מועדון ספורט ימי ביץ' קלאב";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "מועדון ספורט ימי ביץ' קלאב - SUP, Wing Foil, קיאק Surfski בחוף מעגן");
    // Open Graph tags for Facebook/WhatsApp with image
    const ogTags = [{
      property: 'og:title',
      content: "ביץ' קלאב מעגן - מועדון חתירה וגלישה בכנרת"
    }, {
      property: 'og:description',
      content: 'הבית שלכם בכנרת. חוויה ימית מקצועית באווירה משפחתית - SUP, Wing Foil, קיאק Surfski'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fQE8U5PczMXz5vmJNexzo8/939A3565.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "ביץ' קלאב מעגן - מועדון חתירה וגלישה בכנרת"
    }, {
      property: 'twitter:description',
      content: 'הבית שלכם בכנרת. חוויה ימית מקצועית באווירה משפחתית'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fQE8U5PczMXz5vmJNexzo8/939A3565.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
    return () => {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = 'en';
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-right" dir="rtl" data-id="element-1092" data-mp="2hk0w0529yhy3">
      <Navigation data-id="element-1093" data-mp="2vjs6vwxhvi7v" />
      <main data-id="element-1094" data-mp="2vja0i7h4bnm8">
        <Hero data-id="element-1095" data-mp="2vgw5fymfubeo" />
        <ActivitySection data-id="element-1096" data-mp="2qjxiq153t6qi" />
        <SocialImpactSection data-id="element-1097" data-mp="2qkp28dlffe0f" />
        <ContactSection data-id="element-1098" data-mp="2qlgy7pixrdr8" />
      </main>
      <Footer data-id="element-1099" data-mp="3a5pjdcc7t5zl" />
    </div>;
}